<template>
	<div class="search-input">
        <svg-image
            class="search-input--icon"
            :src="'/svg/' + resource_group + '/search.svg'"
            :auto_hover="true"
            @click="submitSearch()"
        ></svg-image>

		<input type="text" v-model="search_edit" class="search-input--input" v-on:keyup.enter="submitSearch()" :placeholder="placeholder">

        <svg-image
            :src="'/svg/' + resource_group + '/close.svg'"

            class="search-input--cancel"
            v-bind:class="search_edit ? 'show' : ''"
            :auto_hover="true"

            highlight="negative"

            @click="clearSearch"
        ></svg-image>
	</div>
</template>

<script>
	export default {
		props: [
			'search',
			'href',
			'placeholder',
            'emit_instead'
		],

		data(){
			return {
				search_edit: '',
			}
		},

		mounted(){
			this.search_edit = this.search || '';
		},

		methods: {
			submitSearch(){
				this.$emit('submit', this.search_edit);
				if (this.emit_instead){
					return;
                }
				window.location.href = this.href + '?search=' + this.search_edit;
			},

			clearSearch(){
				if (this.search && !this.emit_instead){
					window.location.href = this.href;
				}
				else {
					this.search_edit = '';
					this.$emit('input', '');
					this.$emit('submit', '');
				}
			}
		},
        watch: {
			search_edit(val){
				this.$emit('input', val);
            }
        }
	}
</script>
